import * as React from 'react';

import SVGIcon from 'components/svg-icon/SVGIcon';
import {
  ModalFrame,
  ModalFrameFooter,
  ModalFrameInner,
  ModalFrameMessage
} from 'components/modal';
import ActionButton from 'components/buttons/action-button/ActionButton';

import { __t, applyTranslations } from 'utils/language';

import './brand-ccm-onboard-modal.scss';

applyTranslations(require('./brand-ccm-onboard-modal.i18n.json'));

type Props = {
  onCloseModal: () => void
};

const CcmBrandOnboardModal = ({
  onCloseModal
}: Props): JSX.Element => (
  <ModalFrame
    title={__t('brand_ccm_onboard_modal.title')}
  >
    <ModalFrameInner
      narrowContent
    >
      <ModalFrameMessage
        align="center"
      >
        <div className="brand_ccm_onboard_modal__icon">
          <SVGIcon
            name="party-in-circle-green"
            height={96}
            width={96}
          />
        </div>
        <div className="brand_ccm_onboard_modal__step">
          <div className="brand_ccm_onboard_modal__step-title">
            {__t('brand_ccm_onboard_modal.steps.first.title')}
          </div>
          <div
            className="brand_ccm_onboard_modal__step-description"
            dangerouslySetInnerHTML={{
              __html: __t('brand_ccm_onboard_modal.steps.first.description')
            }}
          />
        </div>
        <div className="brand_ccm_onboard_modal__step">
          <div className="brand_ccm_onboard_modal__step-title">
            {__t('brand_ccm_onboard_modal.steps.second.title')}
          </div>
          <div className="brand_ccm_onboard_modal__step-description">
            {__t('brand_ccm_onboard_modal.steps.second.description1')}
          </div>
          <div className="brand_ccm_onboard_modal__step-description">
            {__t('brand_ccm_onboard_modal.steps.second.description2')}
          </div>
        </div>
        <div className="brand_ccm_onboard_modal__step">
          <div className="brand_ccm_onboard_modal__step-title">
            {__t('brand_ccm_onboard_modal.steps.third.title')}
          </div>
          <div className="brand_ccm_onboard_modal__step-description">
            {__t('brand_ccm_onboard_modal.steps.third.description')}
          </div>
        </div>
        <div className="brand_ccm_onboard_modal__description">
          {__t('brand_ccm_onboard_modal.description')}
        </div>
      </ModalFrameMessage>
      <ModalFrameFooter
        noMargin
        className="brand_ccm_onboard_modal__footer"
      >
        <ActionButton
          type="submit"
          color="primary"
          onClick={onCloseModal}
        >
          {__t('brand_ccm_onboard_modal.close_button')}
        </ActionButton>
      </ModalFrameFooter>
    </ModalFrameInner>
  </ModalFrame>
);

export default CcmBrandOnboardModal;
